module.exports = __webpack_public_path__ + "static/media/capital_logo_white2.43ee8a3b.png";